import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import ConfigContext from './contexts/ConfigContext';
import useAuthInitialization from './hooks/useAuthInitialization';

import ScrollToTop from './components/shared/ScrollToTop';
import Error500Page from './components/public/Error500Page';

import history from './modules/history';
import getStore from './redux/store';

function AuthInitializer({ children }) {
  useAuthInitialization();
  return children;
}

function App({ railsContext, data }) {
  const store = getStore(data);
  const routes = require('./routes/routes').default;

  const config = useMemo(() => ({
    ...data.data.city_config,
    ...railsContext,
    url: window.location.href,
    serverSide: false
  }), [data.data.city_config, railsContext]);

  return (
    <ConfigContext.Provider value={config}>
      <Provider store={store}>
        <Router history={history}>
          <ScrollToTop />
          <Sentry.ErrorBoundary fallback={<Error500Page />}>
            <AuthInitializer>
              {routes}
            </AuthInitializer>
          </Sentry.ErrorBoundary>
        </Router>
      </Provider>
    </ConfigContext.Provider>
  );
}

App.propTypes = {
  railsContext: PropTypes.object,
  data: PropTypes.object,
};

export default App;
